import Modal from 'react-modal';

export default function initializeModal(element: string | HTMLElement): void {
  Modal.setAppElement(element);
}
